import { Theme } from '@eversports/react-components/design-tokens/theme'
import BaseLink from '@eversports/react-components/primitives/BaseLink'
import Button from '@eversports/react-components/primitives/Button'
import Flex from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import { useLocation } from 'react-router-dom'

import { Localized } from '../localization/react'

import { HEADER_HEIGHT } from './Header/HeaderComponent'

const useStyles = makeStyles(({ palette, layoutSpacing }: Theme) => ({
  fullPage: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: palette.background.default,
    padding: layoutSpacing.default,
  },
  sectionContained: {
    height: `calc(100% - ${HEADER_HEIGHT}px)`,
  },
}))

export const UnexpectedErrorPage = () => {
  const classes = useStyles()

  return (
    <Flex
      verticalSpacing="default"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={classes.sectionContained}
      data-testid="unexpected-error"
    >
      <Icon icon={Icons.ERROR} color="danger" size="xx-large" />
      <Text textAlign="center" fontWeight="bold">
        <Localized id="unexpected-error-message" />
      </Text>
      <Text textAlign="center">
        <Localized id="unexpected-error-description" />
      </Text>
    </Flex>
  )
}

export const NetworkErrorPage = () => {
  const classes = useStyles()

  return (
    <Flex
      verticalSpacing="default"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={classes.fullPage}
      data-testid="network-error"
    >
      <Icon icon={Icons.INFO} color="info.main" size="xx-large" />
      <Text textAlign="center" fontWeight="bold">
        <Localized id="network-error-message" />
      </Text>
      <Text textAlign="center">
        <Localized id="network-error-description" />
      </Text>
    </Flex>
  )
}

interface BlockingErrorPageProps {
  message: string
}

export const BlockingErrorPage = ({ message }: BlockingErrorPageProps) => {
  const classes = useStyles()

  return (
    <Flex
      verticalSpacing="default"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={classes.sectionContained}
      data-testid="blocking-error"
    >
      <Icon icon={Icons.ERROR} color="danger" size="xx-large" />
      <Text fontWeight="bold">
        <Localized id="blocking-error-message" />
      </Text>
      <Text textAlign="center">{message}</Text>
    </Flex>
  )
}

export const IncorrectLoggedInUserErrorPage = () => {
  const location = useLocation()
  const classes = useStyles()

  const authLink = `/auth?redirectApp=phoenix&redirectPath=${encodeURIComponent(`/phoenix${location.search}`)}`

  return (
    <Flex
      verticalSpacing="default"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={classes.sectionContained}
      data-testid="error"
    >
      <Icon icon={Icons.ERROR} color="danger" size="xx-large" />
      <Text textAlign="center" fontWeight="bold">
        <Localized id="incorrect-user" />
      </Text>
      <Text textAlign="center">
        <Localized id="incorrect-user-description" />
      </Text>
      <BaseLink to={authLink} external>
        <Button variant="primary" marginTop="wide">
          <Localized id="return-to-login" />
        </Button>
      </BaseLink>
    </Flex>
  )
}
